import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { ButtonOutput } from "../button-output";
import { ButtonActionsType } from "../button-actions.type";

@Component({
    selector: "app-text-button",
    templateUrl: "./text-button.component.html",
    styleUrls: ["./text-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextButtonComponent {
  /**
   * Text that should be displayed on the button
   */
  @Input() label = "";

  /**
   * Disabled state of the button
   */
  @Input() disabled: boolean = false;

  /**
   * Optionales Icon vor dem Text, z. B. "icons/24/chevron-left.svg".
   */
  @Input() icon = "";

  @HostBinding("class") get hostClasses() {
    const classList = ["button-text", "text-button"];
    if (this.icon) {
      classList.push("text-button--icon");
    }
    if (this.disabled) {
      classList.push("button--disabled");
    }
    return classList;
  }

  @HostBinding("attr.role") role = "button";

  @HostBinding("attr.tabindex") get tabindex() {
    return this.disabled ? "-1" : "0";
  }

  /**
   * main button output
   */
  @Output() action: EventEmitter<ButtonOutput> =
    new EventEmitter<ButtonOutput>();

  @HostListener("click", ["$event"])
  public click(evt: Event) {
    this.action.emit({
      type: ButtonActionsType.Click,
    });
  }

  // ⚠ Der Host ist kein <button> — Enter und Leertaste loesen von sich aus kein click aus.
  @HostListener("keydown", ["$event"])
  public keydown(evt: KeyboardEvent) {
    if (this.disabled || (evt.key !== "Enter" && evt.key !== " ")) {
      return;
    }

    evt.preventDefault();
    this.action.emit({ type: ButtonActionsType.Click });
  }
}
